export function getFilteredJobs(jobs, { searchString, selectedDepartments, selectedStatuses }) {
  const searchFiltered = searchString
    ? jobs.filter((job) => job.searchableTitle.includes(searchString))
    : jobs;

  const isFilteringStatuses = selectedStatuses.length > 0;

  return searchFiltered.filter((job) => {
    if (selectedDepartments.length > 0 && !selectedDepartments.includes(String(job.department))) {
      return false;
    }
    if (isFilteringStatuses) {
      return selectedStatuses.includes(job.status);
    }
    return true;
  });
}
